import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setTourEdit } from "../../reducer/tourEditReducer";
import { Paths } from "../../router/Paths";
import RoleBasedComponent from "../../components/RoleBasedComponent";

export default function ManageExtraInfoSection({ packageData }: any) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleEdit = () => {
    dispatch(setTourEdit(packageData._id));
    navigate(Paths.tourManagementPackageExtraInfo, {
      state: { packageData },
    });
  };

  return (
    <section className="bg-white p-2 sm:p-6">
      <div className="flex justify-between items-center">
        <p className="text-xl font-bold">Extra Info</p>
        <RoleBasedComponent allowedRoles={["supplier"]}>
          <button
            onClick={handleEdit}
            className="text-sm text-primary underline font-bold"
          >
            Edit
          </button>
        </RoleBasedComponent>
      </div>
      {/* content  */}
      <div className="flex flex-col sm:items-end gap-6">
        <div className="w-full max-w-[836px] flex flex-col sm:flex-row gap-6">
          <div className="w-full">
            <div className="space-y-2">
              <p className="text-sm font-bold">Allowed List</p>
              {packageData?.allowedList?.map((item: string, index: number) => (
                <p key={index} className="text-secondary capitalize">
                  {item}
                </p>
              ))}
            </div>
          </div>
          <div className="w-full">
            <div className="space-y-2">
              <p className="text-sm font-bold">Not Suitable For</p>
              {packageData?.notSuitableFor?.map(
                (item: string, index: number) => (
                  <p key={index} className="text-secondary capitalize">
                    {item}
                  </p>
                )
              )}
            </div>
          </div>
        </div>
        <div className="w-full max-w-[836px] flex flex-col sm:flex-row gap-6">
          <div className="w-full">
            <div className="space-y-2">
              <p className="text-sm font-bold">Prohibited List</p>
              {packageData?.prohibitedList?.map(
                (item: string, index: number) => (
                  <p key={index} className="text-secondary capitalize">
                    {item}
                  </p>
                )
              )}
            </div>
          </div>
          <div className="w-full">
            <div className="space-y-2">
              <p className="text-sm font-bold">Mandatory Items</p>
              {packageData?.mandatoryItems?.map(
                (item: string, index: number) => (
                  <p key={index} className="text-secondary capitalize">
                    {item}
                  </p>
                )
              )}
            </div>
          </div>
        </div>
        <div className="w-full max-w-[836px] flex flex-col sm:flex-row gap-6">
          <div className="w-full text-sm">
            <div className="space-y-2">
              <p className="font-bold">Contact Method</p>
              <p className="text-secondary capitalize">
                {packageData?.contactMethod}
              </p>
            </div>
          </div>
          <div className="w-full text-sm">
            <div className="space-y-2">
              <p className="font-bold">Additonal Informations for Customers</p>
              <p className="text-secondary capitalize">
                {packageData?.informationForCustomers}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
